import {
	fetchOracleRefreshStatus,
	fetchProtocolAutomationHealth,
	type OracleRefreshStatus,
	type ProtocolAutomationHealth,
} from "@/lib/oracle/oracle-autonomy";
import { useQuery } from "@tanstack/react-query";

const POLL_MS = 45_000;

export function useOracleAutonomy() {
	return useQuery({
		queryKey: ["v2", "oracleAutonomy"],
		queryFn: async (): Promise<{
			refresh: OracleRefreshStatus | null;
			automation: ProtocolAutomationHealth | null;
		}> => {
			const [refresh, automation] = await Promise.all([
				fetchOracleRefreshStatus(),
				fetchProtocolAutomationHealth(),
			]);
			return { refresh, automation };
		},
		staleTime: POLL_MS,
		refetchInterval: POLL_MS,
		retry: 1,
	});
}
